import React from "react";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import "./index.scss";

export default function NoMatch() {
  return (
    <div className="no-match">
      <h3>Oops!!! We cannot find the page you are looking for.</h3>
      <h3><Button variant="contained" color="primary" component={Link} to="/">
        {" "}
        Go Home{" "}
      </Button>
      </h3>
    </div>
  );
}
